import type { ProDetailsViewModelFactory } from '@/features/iam'
import type { ProDetailsViewModel } from '@/features/iam/providers/ProDetails/ProDetailsViewModel'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { action, observable } from 'mobx'
import { task } from 'mobx-task'
import type { Id } from '@/infra/id'

export class EditProDetailsDialogViewModel {
  readonly modal = new ModalViewModel()

  @observable accessor details: ProDetailsViewModel | null = null

  constructor(
    private readonly _createProDetailsViewModel: ProDetailsViewModelFactory,
  ) {}

  @action.bound
  open(userPublicId: Id) {
    this.details = this._createProDetailsViewModel(userPublicId, true)
    this.modal.show()
  }

  submit = task.resolved(async () => {
    if (!this.details) {
      return
    }
    const saved = await this.details.save()
    if (saved) {
      this.modal.close()
    }
  })
}
